// Generated with util/create-component.js
import React from "react";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

import { StyledLoading } from "./Loading.styles";
import { LoadingProps } from "./Loading.types";

const Loading: React.FC<LoadingProps> = ({ theme, variant }) => (
  <StyleSheetManager shouldForwardProp={isPropValid}>
    <StyledLoading
      data-testid="Loading"
      theme={theme}
      variant={variant}
      className={`${variant}`}
    />
  </StyleSheetManager>
);

export default Loading;
